var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthenticateFrame',{attrs:{"hasGoBackLink":""},on:{"previousStep":_vm.handleBack}},[_c('ar-text',{style:({
      marginBottom: '20px',
    }),attrs:{"text":"Setup MFA","size":"lg","multiple-lines":""}}),_vm._v(" "),_c('MfaSection',{attrs:{"loading":_vm.isLoading},on:{"success":_vm.handleSuccess}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }